module.exports = __webpack_public_path__ + "static/media/Onest-Regular.0ea3fd8c.woff2";